import styled from '@emotion/styled'
import { Popover } from 'rsuite'

export const BasePopover = styled(Popover)``
